// extracted by mini-css-extract-plugin
export default {"input":"Quotation_input__qm8zD","button":"Quotation_button__bI0EH","popheader":"Quotation_popheader__lDnRN","resumen":"Quotation_resumen__OOzkH"};